import React from 'react';
import { AuthPanel } from '@/components/auth/AuthPanel';

export default function AuthPage() {
  return (
    <div
      className="flex items-center justify-center h-screen bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/images/bg/login.jpg')" }}
    >
      <div className="text-center w-full max-w-md px-8 py-10 bg-gradient-to-tr from-[#0a0f24] to-[#0a0f24] border border-gray-700 rounded-md shadow-lg">
        <div className="mb-6 flex justify-center">
          <div className="relative w-16 h-16 bg-gradient-to-br rounded-full flex items-center justify-center">
            <img src="/images/svg/logo.svg" alt="logo" className="h-full w-full object-contain" />
          </div>
        </div>
        <h2 className="text-white text-xl font-semibold mb-2">Welcome to CyberRange</h2>
        <p className="text-sm text-gray-400 mb-6">Enter your details to Login</p>

        <AuthPanel />

        <div className="text-gray-500 text-xs mt-6 flex justify-center gap-4">
          <a href="https://bhumiitech.com/sla/" target="_blank" rel="noopener noreferrer" className="hover:underline">Terms</a>
          <a href="https://bhumiitech.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="hover:underline">Privacy Policy</a>
          <a href="https://bhumiitech.com/cancellation-and-refund-policy/" target="_blank" rel="noopener noreferrer" className="hover:underline">Support</a>
        </div>

        <p className="text-gray-600 text-xs mt-4">CyberRange, All rights reserved to Bhumi Itech</p>
      </div>
    </div>
  );
}

